import React from 'react';

// Sub-sprint 5: small pill displayed next to an incident's title/synopsis.
// Label comes from the locked 9-item ranking; styling subdued (matches the
// understated metadata treatment used elsewhere — small uppercase, soft chip).
// Display only. No interaction. Render nothing if label is falsy.

export default function CategoryPill({ label }) {
  if (!label) return null;
  return (
    <span
      title={label}
      style={{
        display: 'inline-block',
        fontSize: 9,
        fontWeight: 700,
        color: 'var(--color-text-muted)',
        background: 'var(--color-surface-hover, #f1f5f9)',
        border: '1px solid var(--color-border)',
        borderRadius: 8,
        padding: '1px 6px',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        whiteSpace: 'nowrap',
        fontFamily: 'var(--font-body)',
        flexShrink: 0,
      }}
    >
      {label}
    </span>
  );
}
